(function ($) {
    // Handler for .ready() called.
    var processing, clinicData, foundClinics;
    /** Custom Validator**/
    $.validator.addMethod("alphaonly", function (value, element) {
        var regex = new RegExp("^[a-zA-Z ]+$"); //[a-zA-Z0-9]
        var key = value;

        if (!regex.test(key)) {
            return false;
        }
        return true;
    }, "Please use only alphabetic characters or space.");

    //Validation for ABS form
    $.validator.addMethod("alphanum", function (value, element) {
        var regex = new RegExp("^[-a-zA-Z0-9_\\-!&#*'\" ]+$"); //[a-zA-Z0-9]
        var key = value;

        if (!regex.test(key)) {
            return false;
        }
        return true;
    }, "Please use only alphanumeric characters.");

    $.validator.addMethod("phoneGeneral", function (value, element) {
        // Strip everything that isn't a digit
        var digitsOnly = value.replace(/[\s()+\-\.]/g, '');
        
        // Check if the remaining string is between 7 and 15 digits
        // (15 is the ITU E.164 maximum)
        return this.optional(element) || (digitsOnly.length >= 7 && digitsOnly.length <= 15 && /^\d+$/.test(digitsOnly));
    }, "Please enter a valid phone number.");

    $.validator.addMethod("zipcodeIntl", function (value, element) {
        // Allows alphanumeric characters, spaces, and dashes
        // Minimum 3 characters (e.g., Iceland), maximum 12 (covers all edge cases)
        var regex = new RegExp(/^[a-zA-Z0-9\s\-]{3,12}$/);
        
        return this.optional(element) || regex.test(value);
    }, "Please enter a valid zip/postal code.");

    $.validator.addMethod("notempty", function (value, element) {
        var key = value,
            tempValue = $.trim(value);

        if (tempValue == '') {
            return false;
        }
        return true;
    }, "Please enter a value.");

    $.validator.addMethod('maxfilesize', function (value, element, param) {
        // Length check ensures validation passes if the field is optional and left empty
        if (element.files.length === 0) {
            return true; 
        }

        console.log(element.files);
        
        // Convert MB to Bytes (1 MB = 1048576 Bytes)
        var maxSizeInBytes = param * 1048576;
        
        // Compare the file size
        return element.files[0].size <= maxSizeInBytes;
    }, 'File size must not exceed {0} MB.');

    $.validator.addMethod("nophp", function (value, element) {
        value = _convertSpecialChars(value);
        if (/<\?[=|php]?[\s\S]*?\?>/i.test(value)) {
            return false;
        }
        return true;
    }, "Only plain text allowed.");

    $.validator.addMethod("nohtml", function (value, element) {
        value = _convertSpecialChars(value);
        if (/<\/?[a-z][\s\S]*>/i.test(value)) {
            return false;
        }
        return true;
    }, "No html allowed.");

    function _convertSpecialChars(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    window.onload = window.onresize = function () {
        var cr_overlay = document.getElementsByClassName('cr-overlay');
        var window_width = window.innerWidth - 30;
        if(window_width <= 800){
            $('.img-preview-wrapper').css({'width': window_width + "px", 'height': window_width + "px"});
        }
    }

    if($('#videoWrapper').length > 0){
        const $container = $('#videoWrapper');
        const $video = $('#videoWrapper video');
        const videoNode = $video[0]; // The actual HTML5 element

        $container.on('click', function(e) {
            // Prevent event bubbling if you have other links inside
            e.preventDefault();

            if (videoNode.paused) {
                // PLAYING STATE
                videoNode.play();
                $container.addClass('playing');
            } else {
                // PAUSING/RESET STATE
                videoNode.pause();
                
                // Force return to start so the poster shows properly
                videoNode.currentTime = 0; 
                
                // Optional: videoNode.load() if currentTime doesn't trigger the poster
                $container.removeClass('playing');
            }
        });

        // Reset when video naturally ends
        $video.on('ended', function() {
            videoNode.currentTime = 0;
            $container.removeClass('playing');
        });
    }

    /* Photo Filter */
    var $uploadCrop;
    $uploadCrop = $('#img-preview').croppie({ //You have to initialize croppie after showing the modal or else it won't work
        //enableExif: true,
        url: '/images/filter.png',
        mouseWheelZoom: false,
        enableResize: true,
        viewport: {
            width: '90%',
            height: '90%',
            type: 'circle',
        },
    });

    if($('#fileInput').length > 0){
        $('#fileInput').on('change', function() {
            const file = this.files[0];
            const $display = $('#fileName');

            if (file) {
            $display.text(file.name)
                    .css({ 'color': '#333333', 'font-style': 'normal' });
            } else {
            $display.text('No image uploaded/file name')
                    .css({ 'color': '#a0aab2', 'font-style': 'italic' });
            }

            $(this).valid();
        });
    }

    

    $('#picture-filter-wrapper #fld-photo').on('change', function () {
        if (this.files && this.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                //if ($('#img-preview').hasClass('crop')) {
                $('#img-preview').addClass('ready');
                $uploadCrop.croppie('bind', {
                    url: e.target.result,
                }).then(function () {
                    $('#img-preview').removeClass('off');
                });
                // } else if ($('#img-preview').hasClass('cover')) {
                //     var nimg = '<img src="' + e.target.result + '" class="pending-cover img-fluid" alt="" />';
                //     $('#img-preview').html(nimg);
                // }
            }
            reader.readAsDataURL(this.files[0]);
            $('#save-crop').fadeIn();
        } else {
            $('#save-crop').fadeOut();
        }
    });

    $('#save-crop').on('click', function () {
        $uploadCrop.croppie('result', {
            type: 'canvas',
            size: 'viewport',
        }).then(function (resp) {
            $('#cimage').val(resp);
            $('#filter-form').trigger('submit');
        });
    });

    $('body').on('click', '.ctrl-virtual', function(e){
        e.preventDefault();
        $('#virtual-full-form').slideDown(400, function(){
            $('html, body').animate({
                scrollTop: $('#virtual-volunteer-signup-form').offset().top
            }, 800);
        });
    });


    $('body').on('click', '#zip-results .cta .btn-link', function(e){
        e.preventDefault();
        var hasSlider = false;


        var clinicData = getClinicById(foundClinics, $(this).data('clinic'));
        if(!isEmpty(clinicData)){
            var clinicHtml = '<div class="main-pan">';
            if(!isEmpty(clinicData.logo)){
                clinicHtml += '<div class="clinic-logo-wrapper"><img src="/images/inline/clinics/logos/' + clinicData.logo + '" alt="" /></div>';
            }
            clinicHtml += '<div class="clinic-detail"><h2 class="blue">' + clinicData.organization + '</h2><div class="address">' +  '<span>' + clinicData.address + '</span><span>' + clinicData.city + ' ' + clinicData.state + ' ' + clinicData.zip + '</span>' + '</div><p>' + clinicData.description + '</p></div>';
            clinicHtml += '</div>'; //End main pan
            if(!isEmpty(clinicData.carousel)){
                clinicHtml += '<div class="clinic-carousel-wrapper"><div class="carousel">' + _build_carousel_html(clinicData.carousel) + '"</div></div>';
                hasSlider = true;
            }
            $('#frmModal .modal-body  #clinic-info').html(clinicHtml);
        }

        //$('#frmModal .modal-title > span').text($('.name', $(this).parents('.item')).text());
        if(hasSlider){
            var $slickTarget = $('#frmModal .clinic-carousel-wrapper .carousel');
            $('#frmModal').on('shown.bs.modal', function () {
                $slickTarget.slick({
                    dots: true,
                    infinite: false,
                    prevArrow: '',
                    nextArrow: '',
                    speed: 500,
                    slidesToShow: 1,
                    adaptiveHeight: true
                });
            });
            $('#frmModal').on('hidden.bs.modal', function () {
                if ($slickTarget.hasClass('slick-initialized')) {
                    $slickTarget.slick('unslick');
                }
                $slickTarget.empty();
            });
        }

        var $clonedForm = $('#full-form #full-form-wrapper #volunteer-signup-form').clone();
        // 2. TARGETED UPDATE: Only radio and checkbox inputs
        $clonedForm.find('input[type="radio"], input[type="checkbox"]').each(function() {
            var oldId = $(this).attr('id');
            
            // Only proceed if the element actually has an ID
            if (oldId) {
                var newId = 'modal-' + oldId;
                
                // Update the input ID
                $(this).attr('id', newId);
                
                // Update the corresponding label's "for" attribute
                $clonedForm.find('label[for="' + oldId + '"]').attr('for', newId);
            }
        });
        $clonedForm.attr('id', 'modal-volunteer-signup-form');

        $('#frmModal #form-content').empty().append($clonedForm);
        $('#frmModal #clinic_id').val($(this).data('clinic'));
        $('#frmModal').modal('show');
        validateVolunteerForm("#frmModal #modal-volunteer-signup-form");
    })

    $("#frmModal").on('hidden.bs.modal', function(){
        $('#frmModal .modal-title > span').text('');
        $('#frmModal .modal-body  #clinic-info').html('');
        $('#form-content').html('');
        $('#frmModal #clinic_id').val('');
    });

    if ($('#error-bucket').length > 0) {
        $('html, body').animate({
            scrollTop: $('#error-bucket').offset().top - 200
        }, 200);
    }

    $("#filter-form").submit(function (event) {
        event.preventDefault(); //prevent default action 
        if(processing){
            alert('Already fetching data please wait.');
            return;
        }
        processing = true;
        //alert('Submit Form');
        // form = $('#po-profile-frm')[0];
        // eType = 'multipart/form-data';
        // contentType = false;
        // processData = false;
        //frmdata = new FormData(form);
        $('#save-crop').addClass('loading');
        var frmdata = {};
        var form = $('#filter-form')[0];
        eType = 'multipart/form-data';
        frmdata = new FormData(form);
        frmdata.append('op', 'photo_filter');
        $.ajax({
            type: 'POST',
            enctype: 'multipart/form-data',
            url: 'misc/ajax.php',
            data: frmdata,
            contentType: false,
            cache: false,
            processData: false,
        })
            .done(function (result) {
                //var res = $.parseJSON(result);
                //console.log(res);
                if (!isEmpty(result.file)) {
                    $('#result-img').html('<div><img src="' + result.file + '" alt=""/><p class="mt-2"><a href="' + result.file + '" target="_blank" class="btn btn-primary mb-2">View Image</a></p></div>');
                } else {
                    $('#result-img').html('');
                }
                $('html, body').animate({
                    scrollTop: $('#result-img').offset().top
                }, 800);
                // if (!isEmpty(result.data.success)) {
                //     if ($('.profile-setup-wrapper').length > 0) {
                //         navigatePanel($('.form-step-panel.active'));
                //     } else {
                //         if (!isEmpty(result.data.updated_experiences)) {
                //             if ($('#experience-listing').length > 0) {
                //             $('#experience-listing > ul').fadeOut().remove();
                //             $('#experience-listing').append(result.data.updated_experiences);
                //             $('#profile-edit-modal').modal('hide');
                //             }
                //             po_show_alert('Experiences updated successfully.', 'success');
                //         } else if (!isEmpty(result.data.cropped)) {
                //             //Update Crop and close modal
                //             //$('#profile-pic .photo').append('<img src="" />')
                //             //$('.profile-pic .photo').html('<img src="' + $('#cimage').val() + '" alt="" />');
                //             alert('Profile picture updated successfully.', 'success');
                //         } else {
                //             window.location = window.location.href + '?updated=1';
                //         }
                //     }
                // } else if (!isEmpty(result.data.error)) {
                //     $('#coin-form').prepend('<div id="err-msg" class="po-msg-box alert alert-danger" role="alert">' + result.data.error + '</div>');
                // }
            })
            .fail(function () {
                alert('Some unknown error occured, please try again later.', 'error');
            }).always(function () {
                frmProcessing = false;
                $('#save-crop').removeClass('loading');
            });
    });

    $("#photo-up-frm").validate({
        ignore: [],
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.appendTo(element.parents('.field-input'));
        },
        highlight: function (element) {
            $(element).parents('.field-input').addClass('has-error');
        },
        unhighlight: function (element) {
            $(element).parents('.field-input').removeClass('has-error');
        },
        rules: {
            'entry[firstname]': { required: true, notempty: true, nohtml: true, nophp: true },
            'entry[lastname]': { required: true, notempty: true, nohtml: true, nophp: true },
            'entry[email]': { required: true, email: true},
            'entry[clinic_name]': { required: true, notempty: true, nohtml: true, nophp: true },
            'photo_url': {required: true, maxfilesize: 10 },
        },
        messages: {
            'entry[firstname]': { required: 'Please enter your first name.' },
            'entry[lastname]': { required: 'Please enter your last name.' },
            'entry[email]': { required: 'Please enter your email address.', email: 'Please enter a valid email address.' },
            'entry[clinic_name]': { required: 'Please enter a clinic name.' },
            'photo_url': { required: 'Please select an image to upload.', extension: 'Only images are allowed.' },
        },
        invalidHandler: function (event, validator) {
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).parents('.field-group').offset().top
            }, 800);
        },

        submitHandler: function (form) {
            return true;
        }
    });

   
    $("#zp-frm").validate({
        ignore: ".ignore",
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.appendTo(element.parents('.field-row'));
        },
        highlight: function (element) {
            $(element).parents('.field-row').addClass('has-error');
        },
        rules: {
            'zip': { required: true,  minlength: 5,maxlength: 5,digits: true },
        },
        messages: {
            'zip': {required: 'Please enter a zip code.'},
        },
        invalidHandler: function (event, validator) {
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).parents('.field-group').offset().top
            }, 800);
        },
        submitHandler: function (form) {
            //new FormData(this),
            processInlineForm(new FormData(form));
            return false;
        }
    });

    $('.goto').on('click', function(e){
        e.preventDefault();
        var _target = null;
        if($('#' + $(this).data('section')).length > 0){
          _target = $('#' + $(this).data('section'));
        } else if($('.' + $(this).data('section')).length > 0){
          _target = $('.' + $(this).data('section'));
        }
        if(_target !== null){
          $('html, body').animate({
              scrollTop: _target.offset().top - 20,
          }, 800);
        }
    });

    $("#state-frm").validate({
        ignore: ".ignore",
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.appendTo(element.parents('.field-row'));
        },
        highlight: function (element) {
            $(element).parents('.field-row').addClass('has-error');
        },
        rules: {
            'state': { required: true},
        },
        messages: {
            'state': {required: 'Please select a state.'},
        },
        invalidHandler: function (event, validator) {
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).parents('.field-group').offset().top
            }, 800);
        },

        submitHandler: function (form) {
            //new FormData(this),
            filterByState($('#s_state').val());
            return false;
        }
    });

    $('#s_state').on('change', function(){
        $('#search-results').html('');
        if($('#mock-results').length > 0){
            $('#mock-results').hide();
        }
    })

    $("#entry-form").validate({
        ignore: ".ignore",
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.appendTo(element.parents('.field-input'));
        },
        highlight: function (element) {
            $(element).parents('.field-input').addClass('has-error');
        },
        unhighlight: function (element) {
            $(element).parents('.field-input').removeClass('has-error');
        },
        rules: {
            'entry[name]': { required: true, notempty: true, nohtml: true, nophp: true },
            'entry[email]': { required: true, email: true, notempty: true, nohtml: true, nophp: true },
            'entry[practice]': { required: true, notempty: true, nohtml: true, nophp: true },
            'entry[address]': {nohtml: true, nophp: true },
            'entry[city]': {nohtml: true, nophp: true },
            'entry[state]': {nohtml: true, nophp: true },
            'entry[zip]': { minlength: 5,maxlength: 5,digits: true },
            'entry[social]': {nohtml: true, nophp: true },
        },
        messages: {
            'entry[name]': { required: 'Please enter your name.' },
            'entry[email]': { required: 'Please enter an email address.', email: 'Please enter a valid email address.' },
        },
        invalidHandler: function (event, validator) {
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).parents('.field-group').offset().top
            }, 800);
        },
        submitHandler: function (form) {
            //new FormData(this),
            processForm(new FormData(form));
            return false;
        }
    });
    
    $("#signup-form").validate({
        ignore: ".ignore",
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.appendTo(element.parents('.field-input'));
        },
        highlight: function (element) {
            $(element).parents('.field-input').addClass('has-error');
        },
        unhighlight: function (element) {
            $(element).parents('.field-input').removeClass('has-error');
        },
        rules: {
            'data[firstname]': { required: true, notempty: true, nohtml: true, nophp: true },
            'data[lastname]': { required: true, notempty: true, nohtml: true, nophp: true },
            'data[email]': { required: true, email: true, notempty: true, nohtml: true, nophp: true },
        },
        messages: {
            'data[firstname]': { required: 'Please enter your first name.' },
            'data[lastname]': { required: 'Please enter your last name.' },
            'data[email]': { required: 'Please enter an email address.', email: 'Please enter a valid email address.' },
        },
        invalidHandler: function (event, validator) {
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).parents('.field-group').offset().top
            }, 800);
        },
        submitHandler: function (form) {
            //new FormData(this),
            processSignup(new FormData(form));
            return false;
        }
    });

    if( $("#volunteer-signup-form").length > 0){
        validateVolunteerForm("#volunteer-signup-form");
    }

    if( $("#virtual-volunteer-signup-form").length > 0){
        validateVolunteerForm("#virtual-volunteer-signup-form");
    }


    //Create expression and trap all external links
    $.expr[':'].external = function (obj) {
        return !obj.href.match(/^mailto\:/)
            && (obj.hostname != location.hostname);
    };

    $('a[href$=".pdf"]').prop('target', '_blank').addClass('pdf');
    $('a:external:not(.sub)').addClass('external-link');
    $('.external-link').attr('aria-describedby', 'off-site');
    $('a[href="#"]').attr('role', 'button');
    var externalLink;


    function _build_carousel_html(inputString){
        var parts = inputString.split("|");
        var baseName = parts[0];
        var count = parseInt(parts[1], 10);
        var slides = '';
        for (var i = 1; i <= count; i++) {
            slides += '<img src="/images/inline/clinics/carousels/' + baseName + "-" + i + ".jpg" + '" alt="" />';
        }
        return slides;
    }

    function filterByState(state){
        if(processing){
            alert('Fetching data please wait.');
            return;
        }
        
        if(isEmpty(clinicData)){
            processing = true;
            $('#search-results').html('');
            $('#search-results').addClass('loading');
            $.ajax({
                type: "POST",
                url: 'misc/ajax.php',
                data: { op: "clinics"},
                cache: false,
            })
            .done(function (resp) {
                //if(!isEmpty(resp.clinics)){
                    //console.log("Not adding");
                clinicData = resp; //resp.clinics;
                //}
               
                $('#search-results').html(_buildHtml(state));
            })
            .fail(function () {
                // Some Error Occured
            })
            .always(function (data) {
                processing = false;
                $('#search-results').removeClass('loading');
            });
        } else {
            $('#search-results').html(_buildHtml(state));
        }
    }

    function validateVolunteerForm(selector){
        // We use $(selector) so we can target either the ID or a specific modal form
        $(selector).validate({
            ignore: ".ignore",
            errorElement: "span",
            errorPlacement: function (error, element) {
                error.appendTo(element.parents('.field-input'));
            },
            highlight: function (element) {
                $(element).parents('.field-input').addClass('has-error');
            },
            unhighlight: function (element) {
                $(element).parents('.field-input').removeClass('has-error');
            },
            rules: {
                'data[firstname]': { required: true, notempty: true, nohtml: true, nophp: true },
                'data[lastname]': { required: true, notempty: true, nohtml: true, nophp: true },
                'data[email]': { required: true, email: true, notempty: true, nohtml: true, nophp: true },
                'data[phone]': {required: true, phoneGeneral: true },
                'data[practice]': {required: true, nohtml: true, nophp: true },
                'data[address]': {required: true, nohtml: true, nophp: true },
                'data[city]': {required: true, nohtml: true, nophp: true },
                'data[state]': {required: true, nohtml: true, nophp: true },
                'data[zip]': {required: true, zipcodeIntl: true},
                'data[credentials]': {required: true},
                'data[radius]': {
                    required: function(element) {
                        // Only required if the form is NOT inside a modal
                        return $(element).closest('.modal').length === 0;
                    }
                },
                'data[hours][]': {required: true},
                'data[activities][]': {required: true},
                'age': {required: true},
                'agree': {required: true},
            },
            messages: {
                'data[firstname]': { required: 'Please enter your first name.' },
                'data[lastname]': { required: 'Please enter your last name.' },
                'data[email]': { required: 'Please enter an email address.', email: 'Please enter a valid email address.' },
                'data[phone]': { required: 'Please enter your phone number.' },
                'data[practice]': { required: 'Please enter your practice/employer.' },
                'data[address]': { required: 'Please enter your address.' },
                'data[city]': { required: 'Please enter your city.' },
                'data[state]': { required: 'Please enter your state.' },
                'data[zip]': { required: 'Please enter your zip code.' },
                'data[credentials]': { required: 'Please select your credentials.' },
                'data[radius]': { required: 'How many miles are you willing to travel.' },
                'data[hours][]': { required: 'Please select your preferred hours for volunteering.' },
                'data[activities][]': {required: 'Please select at least 1 activity.'},
                'age': { required: 'You have to be at least 21 years of age.' },
                'agree': { required: 'Please agree to the Official Rules to continue.' }, // Shortened as requested
            },
            invalidHandler: function (event, validator) {
                // Check if we are in a modal. If so, don't scroll the body.
                if (!$(this).closest('.modal').length) {
                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element).parents('.field-group').offset().top
                    }, 800);
                }
            },
            submitHandler: function (form) {
                processSignup(new FormData(form), 'volunteer-signup', selector);
                return false;
            }
        });
    }

    function _buildHtml(state){
        //const result = clinicData.clinics.filter((clinic) => clinic.state == state);
        // const featuredClinics = isEmpty(clinicData) ? null : clinicData.featured_clinics.filter((clinic) => clinic.state == state);
        // const clinicsAlreadyListed = isEmpty(featuredClinics) ? null : featuredClinics.map((clinic) => clinic.name + '|' + clinic.address.trim().toLowerCase());
        //Remove featured clinics so that they are not listed twice on the results
        //console.log(clinicData.other_clinics);
        var html = '';

        const featuredClinics = isEmpty(clinicData) ? null : clinicData.featured_clinics.filter((clinic) => {
            return (clinic.state == state);
        });

        if(!isEmpty(featuredClinics) && (featuredClinics.length > 0)){
            html += '<div class="content mb-4 featured-clinics-box"><h4 class="text-uppercase">Featured Clinics</h4><p class="mb-4 pb-2">On July 8<sup>th</sup>, the clinics listed here will be offering free skin checks to uninsured or underinsured patients.</p>';
            html += '<ul class="plain">';
            featuredClinics.map((item) => {
                html += '<li><strong class="d-block">' + item.name + '</strong>' + item.address + ', ' + item.city + ', ' + item.state + ' ' + item.zip + '</li>';
            }).join('');
            html += '</ul></div>';
        }

        const otherClinics = isEmpty(clinicData) ? null : clinicData.other_clinics.filter((clinic) => {
            return (clinic.state == state);
            //return (clinic.state == state) && !clinicsAlreadyListed.includes(clinic.name + '|' + clinic.address.trim().toLowerCase());
        });
       
        if(!isEmpty(otherClinics) && (otherClinics.length > 0)){
            html += '<div class="search-results pt-3 mb-2"><p class="mb-4">The clinics below may not be participating on July 8, but do offer dermatological care throughout the year.</p><p class="pb-4">You can also visit the <strong><a href="https://nafcclinics.org/" target="_blank" style="color: #ffffff !important;">NAFC website</a></strong> to learn more about programs they offer.</p>';
            html += '<ul class="plain">';
            otherClinics.map((item) => {
                html += '<li class="mb-4"><strong class="d-block">' + item.name + '</strong>' + item.address + '<br /> ' + item.city + ', ' + item.state + ' ' + item.zip + '</li>';
            }).join('');
            html += '</ul></div>';
        }
        if(isEmpty(html)){
            html = '<div class="text-center"><p class="mb-20"><strong>We didn’t find any participating clinics in your state.</strong></p><p>Come back later to see if additional clinics join!</p><p>You can also visit the NAFC website to find a clinic near you and learn about programs they offer (and/or other days you can receive a skin health consultation).</p><p><a href="https://nafcclinics.org/" target="_blank" class="btn lb">Visit NAFC Website</a></p></div>';
        } 
        return html;
    }

    function getClinicById(data, targetId) {
        let foundClinic = null;

        // We use $.each to iterate through the main array
        $.each(data, function(index, item) {
            // Compare the ID inside the 'clinic' sub-object
            if (item.clinic.id == targetId) {
                foundClinic = item.clinic;
                return false; // This "breaks" the jQuery loop early once found
            }
        });
        return foundClinic;
    }

    function processInlineForm(formData) {

        if(processing){
            alert('Already fetching data please wait.');
            return;
        }
        processing = true;
        formData.append('op', 'zip-data');
        $('#zip-results').addClass('loading');
        $('#zip-results').html('');
        foundClinics = null;

        $.ajax({
            type: "POST",
            dataType: 'json',
            url: 'misc/ajax.php',
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
        })
        .done(function (resp) {
            if (!isEmpty(resp.success)) {
                //show_zip_data(resp.coordinates, resp.clinics);
                if(!isEmpty(resp.clinics)){
                    foundClinics = resp.clinics;
                }

                if(!isEmpty(resp.html)){
                    $('#zip-results').html(resp.html);
                    setTimeout(function(){
                        $('html, body').animate({
                            scrollTop: $('#zip-results').offset().top - 200
                        }, 200);
                    }, 500);
                } else {
                    $('#full-form').show();
                    //$('#zip-results').html('<div class="no-results"><p>No clinics in your area are participating this year. <br />To find future volunteer opportunities at your nearest clinic, visit the <strong><a href="https://nafcclinics.org/" target="_blank">NAFC website</a></strong>.</p></div>');
                }
               
            } else if (!isEmpty(resp.error)) {
                if(!isEmpty(resp.zeroResults)){
                    $('#full-form').show();
                    //$('#zip-results').html('<div class="no-results"><p>No clinics in your area are participating this year. <br />To find future volunteer opportunities at your nearest clinic, visit the <strong><a href="https://nafcclinics.org/" target="_blank">NAFC website</a></strong>.</p></div>');
                } else {
                    alert(resp.error);
                }
               
            }
        })
        .fail(function () {
            // Some Error Occured
        })
        .always(function (data) {
            $('#zip-results').removeClass('loading');
            processing = false;
        });
    }
    function _radians(degrees) {
        var TAU = 2 * Math.PI;
        return degrees * TAU / 360;
    }

    function show_zip_data(coordinates, clinics) {
        var res = [];
        var miles = null;
        clinics.forEach(function (clinic, i) {
            miles =  Math.ceil(Math.acos(Math.cos(_radians(90-coordinates.lat)) *Math.cos(_radians(90-clinic.lat)) +Math.sin(_radians(90-coordinates.lat)) *Math.sin(_radians(90-clinic.lat)) *Math.cos(_radians(coordinates.lng-clinic.lng))) * 3959);
            if(miles <= 500){
                res.push({idx: i, miles: miles, clinic: clinics[i]});
            }
        });

        res.sort( function(a,b){
            return a.miles - b.miles
        } );
    }

    function processForm(formData) {
        $('#error-bucket, #success-bucket').fadeOut().remove();
        if (processing) {
            alert('Your submission is being processed, please wait.');
            return;
        }

        var button = $('.frm-submit');
        button.addClass('loading');
        processing = true;
        formData.append('op', 'form-submission');

        $.ajax({
            type: "POST",
            dataType: 'json',
            url: 'misc/ajax.php',
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
            beforeSend: function (xhr) {
                $("#err").fadeOut();
            }
        })
            .done(function (resp) {
                if (!isEmpty(resp.success)) {
                    // $('#survey-form').prepend('<div id="success-bucket">Submission processed successfuly.</div>');
                    _resetform();
                    // setTimeout(function(){
                     window.location = "/thank-you";
                    // }, 5000);
                } else if (!isEmpty(resp.error)) {
                    if ($('#entry-form').length > 0) {
                        $('#entry-form').prepend('<div id="error-bucket">' + resp.error + '</div>');
                    }
                }
            })
            .fail(function () {
                // Some Error Occured
            })
            .always(function (data) {
                processing = false;
                button.removeClass('loading');
                if ($('#error-bucket').length > 0) {
                    $('#frmModal').animate({
                        scrollTop: 0
                    }, 800);
                }
            });
    }

    function processSignup(formData, ftype, selector) {
        ftype = ftype || 'signup-submission'; // Using logical OR
        selector = selector || false;
        $('#error-bucket, #success-bucket').fadeOut().remove();
        if (processing) {
            alert('Your submission is being processed, please wait.');
            return;
        }

        var button = $('.frm-submit');
        button.addClass('loading');
        processing = true;
        formData.append('op', ftype);

        $.ajax({
            type: "POST",
            dataType: 'json',
            url: 'misc/ajax.php',
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
            beforeSend: function (xhr) {
                $("#err").fadeOut();
            }
        })
            .done(function (resp) {
                if (!isEmpty(resp.success)) {
                    if(ftype == 'volunteer-signup'){
                        window.location = "/thank-you";
                    }
                    $('#signup-main-content, #volunteer-signup-form').slideUp(800, function(){
                        $('#signup-ty-msg').slideDown();
                    });
                } else if (!isEmpty(resp.error)) {
                    if(selector){
                        $(selector).prepend('<div id="error-bucket">' + resp.error + '</div>');
                    } else {
                        if ($('#signup-form, #volunteer-signup-form, #modal-volunteer-signup-form').length > 0) {
                            $('#signup-form, #volunteer-signup-form, #modal-volunteer-signup-form').prepend('<div id="error-bucket">' + resp.error + '</div>');
                        }
                    }
                }
            })
            .fail(function () {
                // Some Error Occured
            })
            .always(function (data) {
                processing = false;
                button.removeClass('loading');
                if ($('#error-bucket').length > 0) {
                    if ($('#error-bucket').length > 0) {
                        $('html, body').animate({
                            scrollTop: $('#error-bucket').offset().top - 200
                        }, 200);
                    }
                }
            });
    }


    function _resetform(){
        $("#entry-form")[0].reset();
        if ($('#success-bucket').length > 0) {
            $('html, body').animate({
                scrollTop: $('#success-bucket').offset().top - 10
            }, 1000);
        }
    }

    function isEmpty(mixed_var) {
        mixed_var = jQuery.trim(mixed_var);
        var key;
        if (mixed_var === '' || mixed_var === 0 || mixed_var === '0' || mixed_var === null || mixed_var === false || typeof mixed_var === 'undefined') {
            return true;
        }

        if (typeof mixed_var === 'object') {
            for (key in mixed_var) {
                return false;
            }
            return true;
        }
        return false;
    }

})(jQuery);